import React from 'react';
import './CalendarWeekdays.scss';

interface CalendarWeekdaysProps {
  labels: string[];
}

const CalendarWeekdays: React.FC<CalendarWeekdaysProps> = ({ labels }) => {
  return (
    <div className="events-calendar-page__weekdays">
      {labels.map(label => (
        <div key={label} className="events-calendar-page__weekday">
          {label}
        </div>
      ))}
    </div>
  );
};

export default CalendarWeekdays;
